import React from 'react'

export default function ReportCard({ card }) {
    return (
        <div className="card shadow-sm h-100 overflow-hidden">
            <div className="card-header py-4 px-4 text-center text-white" style={{ backgroundColor: '#5a5a5a' }}>
                <div className="fw-bold text-uppercase fs-6">{card.recruiter_name}</div>
                <div className="fs-7 opacity-90 text-uppercase">{card.location}</div>
            </div>
            <div className="card-body px-0 py-0">
                <MetricRow label="Registros" value={card.registros} variant="primary" />
                <MetricRow label="Contestaron" value={card.contestaron} variant="primary" />
                <MetricRow label="Entrevistas agendadas" value={card.entrevistas_agendadas} variant="primary" />
                <MetricRow label="Entrevistas realizadas" value={card.entrevistas_realizadas} variant="primary" />
                <div className="px-4 py-3 border-top">
                    <div className="fw-bold text-gray-700 fs-8 text-uppercase mb-2">Medios de reclutamiento</div>
                    <div className="d-flex flex-wrap gap-2">
                        {(card.medios || []).length === 0 && <span className="text-muted fs-8">—</span>}
                        {(card.medios || []).map((m) => (
                            <span key={m.name} className="badge badge-light-secondary text-gray-800 fs-8">
                                {m.name} <span className="badge badge-secondary ms-1">{m.count}</span>
                            </span>
                        ))}
                    </div>
                </div>
                <MetricRow label="Ingresos" value={card.ingresos} variant="success" last />
            </div>
        </div>
    )
}

function MetricRow({ label, value, variant, last }) {
    const badgeClass = variant === 'success' ? 'badge-success' : 'badge-primary'

    return (
        <div className={'d-flex justify-content-between align-items-center px-4 py-3 ' + (last ? '' : 'border-bottom border-gray-200')}>
            <span className="text-gray-700 fw-semibold fs-7">{label}</span>
            <span className={`badge ${badgeClass} fs-7`}>{value}</span>
        </div>
    )
}
